module.exports = __webpack_public_path__ + "47efe84ca217f74e71dbf43181e3face.MP3";